// https://github.com/rondorkerin/mui-country-region-select/blob/master/src/CountrySelect.js

/* eslint-disable no-use-before-define */
import React from 'react'
import Autocomplete from '@mui/joy/Autocomplete'

import FormControl from '@mui/joy/FormControl'
import FormHelperText from '@mui/joy/FormHelperText'
import FormLabel from '@mui/joy/FormLabel'
import InfoOutlined from '@mui/icons-material/InfoOutlined'

import { CountrySelect_autocompleteProps, CountrySelect_startDecorator } from './CountrySelect'

import { useController } from 'react-hook-form'

const CountrySelectInFormControl = ({ control, name, label, required }) => {
  const {
    field,
    fieldState,
  } = useController({
    name: name,
    // rules: rules,
    control: control,
  })

  // https://github.com/dohomi/react-hook-form-mui/blob/95506671eb70fe917bc5df3176e18f5281596ae4/packages/rhf-mui/src/AutocompleteElement.tsx#L132
  const currentValue = field.value ? CountrySelect_autocompleteProps.options.find((i) => i.code === field.value) : null

  return (
    <FormControl required={required} error={fieldState.invalid}>
      <FormLabel>{label}</FormLabel>
      <Autocomplete
        {...CountrySelect_autocompleteProps}
        startDecorator={CountrySelect_startDecorator(field.value)}
        name={name}
        value={currentValue}
        onChange={(event, value, reason, details) => {
          // console.log('onChange', { event, value, reason, details })
          const changedVal = value ? value.code : null
          field.onChange(changedVal)
        }}
      />
      {fieldState.error && <FormHelperText><InfoOutlined />{fieldState.error.message}</FormHelperText>}
    </FormControl>
  )
}

// {/* onChange={field.onChange} */}
export default CountrySelectInFormControl
